<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Szolgáltatáskategória</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/data/services/categories/add')"
            icon="el-icon-plus"
            v-can="'data.servicecategory.create'"
          >
            Új Kategória
          </el-button>
        </div>
        <list />
        <template v-if="$route.meta.showAddServiceCategoryDialog">
          <service-category-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateServiceCategoryDialog">
          <service-category-dialog
            :serviceCategoryId="$route.params.id"
            type="update"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
  import Sidebar from '../../../components/data/services/Sidebar';
  import List from '../../../components/data/services/categories/List';
  import ServiceCategoryDialog from '../../../components/data/services/categories/Dialog';

  export default {
    components: {
      Sidebar,
      List,
      ServiceCategoryDialog,
    }
  };
</script>
